import {Component, EventEmitter, Input, Output} from '@angular/core';
import {FormGroup} from "@angular/forms";
import {CustomMessageKey, UtilService} from "library";
import {AuthService} from "projects/store/src/app/services/api/v1/auth.service";


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html'
})

export class LoginComponent {
  submitted: boolean = false;
  loading: boolean = false;

  @Input() form!: FormGroup;
  @Input() srcLogo: string = '';
  @Output() response = new EventEmitter();

  constructor(private authService: AuthService, private utilService: UtilService) {
    this.utilService.disablePageLoading();
  }

  checkCredential() {
    this.loading = true;
    this.submitted = true;
    this.response.emit();
  }

  gotoForgotPassword() {
    this.authService.gotoSalesModule('recuperar-clave');
  }

  get f() {
    return this.form.controls;
  }

  protected readonly CustomMessageKey = CustomMessageKey;
}
